// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "assetGroup", "asset" ]
  static values = {
    templateUrl: String,
    fieldId: String,
    fieldName: String,
  }  

  connect() {
    this.assetTarget.style.display='none'
  }

  selectGroup() {
    const url = this.templateUrlValue.replace("ObjectId", this.assetGroupTarget.value.toString())
    const el = `
      <select id="${this.fieldIdValue}" name="${this.fieldNameValue}" data-placeholder="Serial Num or Ref" data-ajax--url="${url}" class="select2" style="width:220px"></select>`
    this.assetTarget.innerHTML=el

    init_select2()
    this.assetTarget.style.display='inherit'
  }

}
